<template>
  <div class="max-w-3xl mx-auto">
    <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Email notifications
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Subscribe for abandoned carts alerts through emails
          </p>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <form>
            <fieldset>
              <legend class="text-base leading-6 font-medium text-gray-900">
                Users
              </legend>
              <div class="mt-4" v-for="(user, index) of users" :key="index">
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input
                      :id="`pref_${index}`"
                      v-model="user.emailNotification"
                      type="checkbox"
                      class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      @input="changeNotificationSetting(user)"
                    />
                  </div>
                  <div class="ml-3 text-sm leading-5">
                    <label
                      :for="`pref_${index}`"
                      class="font-medium text-gray-700"
                      >{{ user.email }}</label
                    >
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
    <!-- <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Team Inbox Push notifications
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Subscribe for new message notifications in team inbox
          </p>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <fieldset>
            <div>
              <button @click="enableMessaging">Subscribe</button>
            </div>
          </fieldset>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getMessaging, getToken, isSupported } from "firebase/messaging";

export default {
  data() {
    return {
      users: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch("getUsers").then(response => {
        this.users = response.users;
      });
    },
    changeNotificationSetting(user) {
      this.$store.dispatch("updateNotification", {
        requestParams: {
          userId: user.id,
          emailNotification: !user.emailNotification
        }
      });
    },
    async enableMessaging() {
      try {
        const isMessagingSupported = await isSupported();
        if (isMessagingSupported) {
          const messaging = getMessaging();
          getToken(messaging, { vapidKey: process.env.VUE_APP_FCM_VAPID })
            .then(currentToken => {
              if (currentToken) {
                this.$store.dispatch("Inbox/updateNotificationToken", {
                  requestParams: {
                    token: currentToken
                  }
                });
                console.log("current token", currentToken);
              } else {
                // Show permission request UI
                console.log(
                  "No registration token available. Request permission to generate one."
                );
                // ...
              }
            })
            .catch(err => {
              console.log("An error occurred while retrieving token. ", err);
              // ...
            });
        }
      } catch (error) {
        console.log("mesaging not initialized");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
